"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlJoin = void 0;

var _urlJoin = _interopRequireDefault(require("url-join"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */

/**
 * Build URL from URL-JOIN library
 * @param {String} args all path what you need to join
 * @returns {String} the built path
 * @example
 * // return /api/user/123456?name=John&lastName=Doe
 * urlJoin("/api/user/123456", "?name=John&lastName=Doe")
 * @example
 * // return /content/post/this-is-a-good-post
 * urlJoin("/content/post///", "//this-is-a-good-post")
 */
var urlJoin = function urlJoin() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _urlJoin.default)(args);
};

exports.urlJoin = urlJoin;